// src/layouts/GlobalStyles.js
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    background-color: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.textPrimary};
    font-family: ${(props) => props.theme.typography.fontFamily};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    height: 100vh;
    overflow-x: hidden;
  }

  #root {
    height: 100%;
  }

  input, textarea, button {
    font-family: inherit;
  }

  a {
    text-decoration: none;
    color: ${(props) => props.theme.colors.primary};

    &:hover {
      text-decoration: none;
      color: ${(props) => props.theme.colors.primary}dd;
    }
  }

  /* Mobile optimizations */
  @media (max-width: 768px) {
    html {
      font-size: 14px; /* Slightly smaller base font size for mobile */
    }

    input, select, textarea {
      font-size: 16px; /* Prevent zoom on focus in iOS */
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  .icon-spin {
    animation: spin 1s linear infinite;
  }
`;

export default GlobalStyles;

// // src/layouts/GlobalStyles.js
// import { createGlobalStyle } from 'styled-components';

// const GlobalStyles = createGlobalStyle`
//   *, *::before, *::after {
//     margin: 0;
//     padding: 0;
//     box-sizing: border-box;
//   }

//   body {
//     margin: 0;
//     padding: 0;
//     background-color: ${(props) => props.theme.colors.background};  
//     color: ${(props) => props.theme.colors.textPrimary};  
//     font-family: ${(props) => props.theme.typography.fontFamily};  
//     -webkit-font-smoothing: antialiased;
//     -moz-osx-font-smoothing: grayscale;
//     height: 100vh; /* Ensure body takes full viewport height */
//   }

//   input, textarea, button {
//     font-family: inherit;
//     font-size: 1.2em;
//   }

//   a {
//     text-decoration: none;
//     color: ${(props) => props.theme.colors.primary};  
//   }

//   a:hover {
//     text-decoration: underline;
//     color: ${(props) => props.theme.colors.primaryDark};
//   }
  
//   h1, h2, h3 {
//     padding: ${(props) => props.theme.spacing(3)}
//   }

//   /* Responsive typography and inputs for mobile */
//   @media (max-width: 768px) {
//     body {
//       font-size: ${(props) => props.theme.typography.fontSize.medium}; /* Make body text larger */
//     }

//     input, button {
//       font-size: ${(props) => props.theme.typography.fontSize.large}; /* Make inputs larger */
//       padding: ${(props) => props.theme.spacing(2)}; /* More padding on mobile */
//     }
//   }
// `;

// export default GlobalStyles;
